import type { RegraValidade } from '@/modulos/operacional/pre-credenciamento/contrato';

/**
 * Contrato da tela de documentos do credenciado com a API
 * `apps/api/src/modulos/portal-credenciado-documentos` (README do módulo). A
 * regra — catálogo do edital, situação, quem pode enviar — é do banco (0279);
 * aqui só se descreve o que chega e o que vai.
 */

export const API_DOCUMENTOS = '/bff/v1/portal-credenciado-documentos';

/** Natureza do documento: da empresa, ou de um veículo, condutor ou monitor dela. */
export type Natureza = 'EMPRESA' | 'VEICULO' | 'CONDUTOR' | 'MONITOR';

export type SituacaoDoDocumento = 'PENDENTE' | 'EM_ANALISE' | 'APROVADO' | 'REJEITADO' | 'VENCIDO';

/** Placa, marca e modelo do veículo; nome e CPF (inteiro, só dígitos) do colaborador; vazio na empresa. */
export interface RecursoDoDocumento {
  placa?: string | null;
  marca?: string | null;
  modelo?: string | null;
  nome?: string | null;
  cpf?: string | null;
}

/** Um documento exigido pelo edital, num recurso do cadastro. */
export interface ItemDaApi {
  natureza: Natureza;
  recursoId: string;
  recurso: RecursoDoDocumento;
  requisito: {
    codigo: string;
    titulo: string;
    descricao: string | null;
    itemEdital: string | null;
    regraValidade: RegraValidade;
    obrigatorio: boolean;
    enviadoPeloDtp: boolean;
  };
  situacao: SituacaoDoDocumento;
  /** Versão atual; `origem: 'DOSSIE'` é o documento da empresa aprovado no pré-credenciamento. */
  documento: {
    id: string;
    origem: 'J05' | 'DOSSIE';
    versao: number;
    arquivoNome: string;
    enviadoEm: string;
    venceEm: string | null;
  } | null;
  podeEnviar: boolean;
}

export interface ContagemDosDocumentos {
  pendente: number;
  emAnalise: number;
  aprovado: number;
  rejeitado: number;
  vencido: number;
  /** Obrigatórios em Pendente, Rejeitado ou Vencido: o resumo do topo. */
  pendenciasObrigatorias: number;
}

/** `state` de `GET .../state`. A contagem é da lista inteira, não da página. */
export interface EstadoDosDocumentos {
  fase: 'PRONTO' | 'VAZIO';
  pagina: number;
  tamanho: number;
  total: number;
  contagem: ContagemDosDocumentos;
  itens: ItemDaApi[];
}

export interface Envelope<T> {
  contract_version: string;
  screen: string;
  event: { verb: string; outcome: string; at: string };
  state: T;
}

/** Corpo de `POST .../documentos`. */
export interface EnvioDeDocumento {
  natureza: Natureza;
  /** Obrigatório, exceto na EMPRESA (onde o recurso é o próprio cadastro). */
  recursoId?: string;
  requisito: string;
  arquivoNome: string;
  conteudoBase64: string;
  emitidoEm?: string;
  validadeEm?: string;
  /** Exigido pela API no reenvio (Rejeitado ou Vencido). */
  motivo?: string;
  chaveIdempotencia: string;
}

export interface DocumentoEnviado {
  documentoId: string;
  versao: number;
  situacao: string;
  venceEm: string | null;
  repetida: boolean;
}
